import Resolution from '@/helpers/Resolution'
import GameElement from '../../GameElement'
import * as PIXI from 'pixi.js'
import { animate } from '@/helpers/AnimationHelper'
import PlayerService from '../../services/PlayerService'
import Web3 from 'web3'
import MainBitmapText from '../../pixi-scale/MainBitmapText'
import ModalComponent from './ModalComponent'

export default class SpiceModal extends ModalComponent {
    private amount!: PIXI.BitmapText
    private textIndicator: PIXI.Sprite = PIXI.Sprite.from('pixel')
    private indicatorInterval: NodeJS.Timeout

    constructor() {
        super(200, 104)
        this.hPosistion = 35

        const titleBottom = PIXI.Sprite.from('modal_bottom_title')
        titleBottom.x = (this.modalWidth - titleBottom.width) / 2
        titleBottom.y = this.modalHeight - 1

        const titleText = new MainBitmapText('MUST', {
            fontSize: 5
        })
        titleText.x = (this.modalWidth - titleText.width) / 2
        titleText.y = titleBottom.y + 1
        this.modalContainer.addChild(titleBottom)
        this.modalContainer.addChild(titleText)

        const title2 = new MainBitmapText('Allow Cometh to transfer your MUST', {
            fontSize: 6
        })
        title2.y = 6
        title2.x = Math.floor(this.modalWidth / 2 - title2.width / 2)

        const title3 = new MainBitmapText('when you pull to another miner.', {
            fontSize: 6
        })
        title3.y = title2.y + title2.height
        title3.x = Math.floor(this.modalWidth / 2 - title3.width / 2)

        const allowance = PlayerService.getInstance().allowance

        const currentAllowance = new MainBitmapText('Current allowance: ' + Web3.utils.fromWei(allowance, 'ether'), { fontSize: 6 })
        currentAllowance.y = title3.y + title3.height + 6
        currentAllowance.x = Math.floor(this.modalWidth / 2 - currentAllowance.width / 2)

        const inputLine = PIXI.Sprite.from('pixel')
        inputLine.width = 80
        inputLine.interactive = true
        inputLine.cursor = 'pointer'
        inputLine.hitArea = new PIXI.Rectangle(-16, -16, 80, 16)
        inputLine.x = (this.modalWidth - inputLine.width) / 2
        inputLine.y = 64

        const amountIcon = PIXI.Sprite.from('ic_spice')
        amountIcon.y = 52
        amountIcon.x = 134

        this.amount = new MainBitmapText('1000000', {
            fontSize: 6
        })

        this.amount.x = (this.modalWidth - inputLine.width) / 2
        this.amount.y = 53.5

        this.textIndicator.height = 5
        this.textIndicator.y = 55
        this.textIndicator.x = this.amount.x + this.amount.width

        this.indicatorInterval = setInterval(() => {
            this.textIndicator.visible = !this.textIndicator.visible
        }, 500)

        const btn = PIXI.Sprite.from('btn_big')
        btn.x = this.modalWidth / 2 - btn.width / 2
        btn.y = 78
        btn.interactive = true
        btn.cursor = 'pointer'
        btn.on('pointerdown', () => {
            btn.texture = PIXI.Texture.from('btn_big_pressed')
        })
        btn.on('pointerup', () => {
            btn.texture = PIXI.Texture.from('btn_big')
        })
        btn.on('mouseout', () => {
            btn.texture = PIXI.Texture.from('btn_big')
        })
        btn.on('pointertap', async () => {
            const cost = parseFloat(this.amount.text)

            if (!isNaN(cost)) {
                await PlayerService.getInstance().approveGame(cost)
            }

            this.onExit()
        })

        const btnText = new MainBitmapText('CONFIRM', {
            fontSize: 6
        })
        btnText.x = Math.floor(this.modalWidth / 2 - btnText.width / 2)
        btnText.y = 81

        document.addEventListener('keydown', this.onKeyDown)

        this.modalContainer.addChild(title2)
        this.modalContainer.addChild(title3)
        this.modalContainer.addChild(currentAllowance)
        this.modalContainer.addChild(inputLine)
        this.modalContainer.addChild(amountIcon)
        this.modalContainer.addChild(this.amount)
        this.modalContainer.addChild(this.textIndicator)
        this.modalContainer.addChild(btn)
        this.modalContainer.addChild(btnText)
        this.modalContainer.addChild(titleBottom)
        this.modalContainer.addChild(titleText)

        this.setPositions()

        this.loader.visible = false
        this.dataContainer.visible = true
    }

    public onKeyDown = (event: KeyboardEvent) => {
        if (event.code == 'Backspace') {
            this.amount.text = this.amount.text.substr(0, this.amount.text.length - 1)
            event.preventDefault()
        }

        const value = parseInt(event.key)
        if (isNaN(value)) {
            if ((event.key == '.' || event.key == ',') && this.amount.text.indexOf('.') < 0) {
                this.amount.text += '.'
            }
        } else {
            this.amount.text = this.amount.text += value.toFixed(0)
        }
        this.textIndicator.x = this.amount.x + this.amount.width
    }
}
